var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "card card--image", attrs: { to: _vm.link } },
    [
      _vm.flags && _vm.member.countries
        ? _c(
            "div",
            { staticClass: "card__flags" },
            _vm._l(_vm.member.countries, function (country, index) {
              return _c("img", {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: country.name,
                    expression: "country.name",
                  },
                ],
                key: index,
                attrs: { src: country.flag, alt: "" },
              })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.member.logo
        ? _c("img", {
            attrs: { src: `/images/logo/${_vm.member.id}`, alt: "" },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }